import {Axios} from "@/shared/api/axiosInstance.ts";
import {ConfirmResetPasswordReq, LoginReq, LoginRes, RefreshSessionReq, ResetPasswordReq} from "@/shared/types";

const login = (body: LoginReq): Promise<LoginRes> =>
  Axios.post<any, LoginRes>('/auth/login', body);

const refreshSession = (body: RefreshSessionReq): Promise<LoginRes> =>
  Axios.post<any, LoginRes>('/auth/refresh-token', body);

const resetPassword = (body: ResetPasswordReq): Promise<void> =>
  Axios.post<any, void>('/auth/reset-password', body);

const confirmResetPassword = (body: ConfirmResetPasswordReq): Promise<void> =>
  Axios.post<any, void>('/auth/confirm-reset-password', body);

export {
  login,
  refreshSession,
  resetPassword,
  confirmResetPassword,
};
